"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.isBrowser=function(){return"undefined"!=typeof window},exports.isIOS=function(){return/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream};
//# sourceMappingURL=browserUtils.js.map
